import { render, staticRenderFns } from "./citizenship.vue?vue&type=template&id=9163b950&"
import script from "./citizenship.vue?vue&type=script&lang=js&"
export * from "./citizenship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports